// extracted by mini-css-extract-plugin
export default {"productList":"fhqNG","lastTitle":"ocyYF","emptyResponse":"Sl7lV","container":"OEVO7"};